<div class="div-arriere-plan-action" (click)="clicAction($event)"></div>
<div class="div-global-action" (click)="clicAction($event)">
  <div id="center-square">
    <div class="text-holder">
      <h1 class="header_title title">
        LE VOTE EST MOMENTANÉMENT SUSPENDU.
      </h1>

      <div class="text-center">
        <img src="assets/pause-icon.svg" alt="alert" style="margin-bottom: 30px;">
        <p class="no-margin dark-blue bold">{{title}}</p>
        <p class="no-margin dark-blue flex content-center gap-10"><img src="assets/calendar25.svg" alt="alert">{{formattedDateRange}}</p>
      </div>


      <p class="dark-blue text-center"><span class="bold">Message d'information du bureau de vote :</span><br>{{message}}</p>
    </div>